import { getAppUrl } from '@/utils'
import type { AxiosResponse } from 'axios'
import { httpClient } from '@/apis/index.ts'

export const getUserInfo = async () => {
  try {
    const res: AxiosResponse = await httpClient.post(`/iam/user/userInfo`)
    return res.data
  } catch (e) {
    console.log(e)
  }
}

export const changePassword = async () => {
  const res: AxiosResponse = await httpClient.post('/iam/user/request-change-pwd')

  return res.data
}

export async function getAuthInfo() {
  const res = await httpClient.post(`${getAppUrl()}/api/auth/info`)
  return res.data.body
}

export async function logout() {
  try {
    await httpClient.post(`${getAppUrl()}/api/auth/logout`)
  } catch (error) {
    console.error('Error during logout:', error)
  }
}
